import axios from "../config/axiosInstance";

export const tourService = {
  getAllTours: async ({
    page = 1,
    pageSize = 3,
    search = "",
    priceMin = null,
    priceMax = null,
    categories = null,
    discounts = null,
    newest = null,
    bestsellers = null,
    reviews = null,
    sortBy = null,
  }) => {
    try {
      const params = new URLSearchParams();
      params.append("page", page);
      params.append("pageSize", pageSize);
      params.append("search", search);

      // Chỉ thêm các tham số nếu chúng có giá trị hợp lệ
      if (priceMin !== null) params.append("priceMin", priceMin);
      if (priceMax !== null) params.append("priceMax", priceMax);
      if (categories?.length)
        categories.forEach((cat) => params.append("categories", cat));
      if (discounts?.length)
        discounts.forEach((disc) => params.append("discounts", disc));
      if (newest?.length)
        newest.forEach((newItem) => params.append("newest", newItem));
      if (bestsellers?.length)
        bestsellers.forEach((best) => params.append("bestsellers", best));
      if (reviews?.length)
        reviews.forEach((rev) => params.append("reviews", rev));
      if (sortBy) params.append("sortBy", sortBy);

      const response = await axios.get(`/tours/get-all-tours`, { params });
      return response.data;
    } catch (error) {
      console.error("Error fetching tours:", error);
      throw error;
    }
  },

  getTourById: async (tourId) => {
    try {
      const response = await axios.get(`/tours/get-tour-by-id/${tourId}`);
      console.log(response.data);
      return response.data;
    } catch (error) {
      console.error(`Error fetching tour with ID ${tourId}:`, error);
      throw error;
    }
  },

  createTour: async (tourData) => {
    try {
      const response = await axios.post(`/tours/create-tour`, tourData);
      return response.data;
    } catch (error) {
      console.error("Error creating tour:", error);
      throw error;
    }
  },

  updateTour: async (tourId, tourData) => {
    try {
      const response = await axios.put(
        `/tours/update-tour/${tourId}`,
        tourData
      );
      return response.data;
    } catch (error) {
      console.error(`Error updating tour with ID ${tourId}:`, error);
      throw error;
    }
  },

  deleteTour: async (tourId) => {
    try {
      const response = await axios.delete(`/tours/${tourId}`);
      return response.data;
    } catch (error) {
      console.error(`Error deleting tour with ID ${tourId}:`, error);
      throw error;
    }
  },

  fetchTourSearch: async (destination, page, pageSize) => {
    return await axios.get(`/tours`, {
      params: {
        destination: destination,
        page: page,
        pageSize: pageSize,
      },
    });
  },

  getCategoriesWithTourInfo: async () => {
    try {
      const response = await axios.get(`/tours/get-categories-with-tour-info`);
      return response.data;
    } catch (error) {
      console.error("Error fetching categories with tour info:", error);
      throw error;
    }
  },

  // Lấy 10 tour có đánh giá cao nhất
  getTopRatedTours: async () => {
    try {
      const response = await axios.get(`/tours/get-top-rated-tours`);
      return response.data;
    } catch (error) {
      console.error("Error fetching top rated tours:", error);
      throw error;
    }
  },

  // Lấy 10 tour có nhiều booking nhất
  getTopBookedTours: async () => {
    try {
      const response = await axios.get(`/tours/get-top-booked-tours`);
      return response.data;
    } catch (error) {
      console.error("Error fetching top booked tours:", error);
      throw error;
    }
  },

  // Lấy tour có discount cao nhất
  getTopDiscountedTours: async (limit = 10) => {
    try {
      const response = await axios.get(
        `/tours/get-top-discounted-tours?limit=${limit}`
      );
      return response.data; // Trả về toàn bộ response.data (bao gồm message và data)
    } catch (error) {
      console.error("Error fetching top discounted tours:", error);
      throw error;
    }
  },

  getPersonalizedToursByUser: async (userId, status = null) => {
    try {
      console.log(
        "Requesting personalized tours for userId:",
        userId,
        "status:",
        status
      );
      const response = await axios.get(
        `/tours/get-personalized-tours-by-user`,
        {
          params: { userId, status },
        }
      );
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  getToursByIds: async (tourIds) => {
    try {
      // API endpoint này nhận một mảng các ID trong body của request
      const response = await axios.post(`/tours/get-tours-by-ids`, tourIds);
      return response.data;
    } catch (error) {
      console.error("Error fetching tours by IDs:", error);
      throw error;
    }
  },
};
